import { useTranslation } from 'react-i18next';
import IconBack from '../../../../assets/Images/icons/icon-back';
import { ROUTER } from '../../../../constants/router';
import { useNavigate } from 'react-router-dom';
import Steps from './components/Steps';
import { BackTop } from 'antd';

const TemplateConsent = ({ edit }) => {
    const { t } = useTranslation('consent');
    const navigate = useNavigate();

    return (
        <>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() =>
                        navigate(`${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}`)
                    }
                >
                    <IconBack />
                </div>
                {edit ? t('Edit Template Design') : t('Add Template Design')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('ConsentManagement')} /
                </span>
                <span className="text-sm text-gray-400">
                    Template Design /{' '}
                </span>
                <span>
                    {edit
                        ? t('Edit Template Design')
                        : t('Add Template Design')}
                </span>
            </div>
            <Steps edit={edit} />
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </>
    );
};

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

export default TemplateConsent;
